import { FC } from 'react';
import styled from 'styled-components';
import { RouteComponentProps } from '@reach/router';
import { Sidebar } from './Sidebar';
import { Screen } from './Screen';
import { colors } from '../config/theme';

export const ScreenRoute: FC<RouteProps> = ({ file, filter }) => (
  <Wrapper>
    <Sidebar />
    <Screen file={file} filter={filter} />
  </Wrapper>
);

const Wrapper = styled.div`
  background: ${colors.blue_grey_050};
  min-height: 100vh;
`;

interface RouteProps extends RouteComponentProps {
  file: string;
  filter: string;
}
